import React, { useEffect, useState } from "react";
import { DATE_FORMAT_LIST } from "../../../../../configs/AppConfig";
import DocumentPreviewModal from "../../create/DocumentPreviewModal";
import mammoth from 'mammoth';

function DocumentViewTemplate(props) {
    const [docName, setDocName] = useState('');
    const [docDetail, setDocDetail] = useState('');
    const [docFileList, setDocFileList] = useState([]);
    const [isDateFormat, setIsDateFormat] = useState(false);
    const [dateFormat, setDateFormat] = useState(0);
    const [previewFile, setPreviewFile] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [docxPreviewHtml, setDocxPreviewHtml] = useState('');
    const [isDocxLoading, setIsDocxLoading] = useState(false);

    useEffect(() => {
        setDocName(props.docData.name);
        setDocDetail(props.docData.detail);
        setDocFileList(props.docData.files);
        if (props?.docData?.date_format > 0) {
            setIsDateFormat(true);
            setDateFormat(props?.docData?.date_format);
        } else {
            setIsDateFormat(false);
            setDateFormat(0);
        }
    }, [props.docData]);

    const closeDocumentModel = (e) => {
        e.preventDefault();

        props.setDocData({
            id: 0,
            name: '',
            detail: '',
            files: [],
            date_format: 0,
            remove_doc_id: []
        });
    };

    const handleDateFormat = (e) => {
        setIsDateFormat(e.target.checked);
        setDateFormat(0);
    };

    // Helper to get file extension
    const getFileExtension = (name) => {
        if (!name) return '';
        return name.split('.').pop().toLowerCase();
    };

    // Helper to get preview URL
    const getPreviewUrl = (file) => {
        // For backend/site files
        if (file.path) return file.path;
        if (file.file_path) return file.file_path;
        // For local uploads (no preview)
        return null;
    };

    // Handler for preview click
    const handlePreviewFile = async (file) => {
        setDocxPreviewHtml('');
        setIsDocxLoading(false);
        setPreviewFile(file);
        setIsPreviewModalOpen(true);

        // Only for docx files
        if (getFileExtension(file.name) === 'docx' && (file.path || file.file_path)) {
            setIsDocxLoading(true);
            try {
                const url = file.path || file.file_path;
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch .docx file');
                const arrayBuffer = await response.arrayBuffer();
                const result = await mammoth.convertToHtml({ arrayBuffer });
                setDocxPreviewHtml(result.value);
            } catch (err) {
                setDocxPreviewHtml('<div style="color:red">Failed to load .docx preview</div>');
            } finally {
                setIsDocxLoading(false);
            }
        }
    };

    // Download handler for local files
    const handleLocalFileDownload = (fileObj) => {
        if (fileObj && fileObj.file) {
            const url = URL.createObjectURL(fileObj.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileObj.name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        }
    };

    return (
        // <div className="offcanvas offcanvas-end AddDocument"data-bs-scroll="false"  tabIndex="-1" id="Add-document"
        //     data-bs-backdrop="static" data-bs-keyboard="true" aria-labelledby="Add-documentLabel">
        <div
            className="offcanvas offcanvas-end Add-Recipients offcanvas.fade"
            data-bs-scroll="false"
            tabIndex="-1"
            data-bs-keyboard="true"
            data-bs-backdrop="static"
            id="Add-document"
            aria-labelledby="Add-documentLabel"
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="Add-documentLabel">View Documents</h5>
                <button type="button" className="btn btn-close close_btn text-reset " data-bs-dismiss="offcanvas"
                    onClick={closeDocumentModel} aria-label="Close">
                    <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
            </div>
            <div className="offcanvas-body">
                <div className="card mb-4 rounded mx-3">
                    <div className="mb-3">
                        <label className="form-label mb-0">Documents Details</label>
                    </div>
                    <div className="mb-3">
                        <div className="d-flex">
                            <input type="text" className="form-control" aria-describedby="emailHelp" value={docName}
                                readOnly onChange={(e) => setDocName(e.target.value)}
                                placeholder="Enter Document Name" />
                            <i className="bi bi-info-circle ms-1 cur-pointer" aria-hidden="true" data-toggle="tooltip"
                                data-placement="right" title="Requested Document Name" />
                        </div>
                    </div>
                    <div className="d-flex">
                        <textarea className="form-control" rows="3" value={docDetail} readOnly
                            onChange={(e) => setDocDetail(e.target.value)}
                            placeholder="Enter Document Description" />
                        <i className="bi bi-info-circle ms-1 cur-pointer" aria-hidden="true" data-toggle="tooltip"
                            data-placement="right" title="Document Description" />
                    </div>
                </div>
                {/* <div className="card mb-4 rounded add_document mx-3" id="additional_field">
                    <div className="row">
                        <div className="mb-2">
                            <input className="form-check-input" checked={isDateFormat} onChange={handleDateFormat}
                                   type="checkbox" id="expiry_date" disabled/>
                            <label className="form-label ms-2" htmlFor="expiry_date">Add Expiry Date</label>
                        </div>
                        {isDateFormat === true && (
                            <div className="mb-3">
                                <select className="form-select" value={dateFormat} disabled
                                        onChange={(e) => setDateFormat(e.target.value)}>
                                    <option value={0}>Select date format</option>
                                    {DATE_FORMAT_LIST.map((item, index) =>
                                        <option value={item.id} key={index}>{item.text}</option>
                                    )}
                                </select>
                            </div>
                        )}
                    </div>
                </div> */}
                <div className="card mb-5 rounded add_document mx-3">
                    <div className="mb-3">
                        <label className="form-label mb-0">Send additional documents to your clients.</label>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="mb-3 download_document">
                                {docFileList.map((item, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <span
                                            style={{ display: 'inline-flex', alignItems: 'center', cursor: getPreviewUrl(item) ? 'pointer' : 'not-allowed' }}
                                            onClick={() => getPreviewUrl(item) && handlePreviewFile(item)}
                                            data-toggle="tooltip"
                                            title={getPreviewUrl(item) ? 'Click to Preview Document' : 'No preview available'}
                                        >
                                            {item.name} ({item.kb} KB)
                                            {/* Download icon/button */}
                                            <span
                                                style={{ cursor: 'pointer', marginLeft: 8 }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (item.path || item.file_path) {
                                                        // Direct download for server files
                                                        const url = item.path || item.file_path;
                                                        const a = document.createElement('a');
                                                        a.href = url;
                                                        a.download = item.name;
                                                        document.body.appendChild(a);
                                                        a.click();
                                                        setTimeout(() => {
                                                            document.body.removeChild(a);
                                                        }, 100);
                                                    } else if (item.file) {
                                                        handleLocalFileDownload(item);
                                                    }
                                                }}
                                                title="Download Document"
                                            >
                                                <i className="bi bi-download" aria-hidden="true" />
                                            </span>
                                        </span>
                                    </div>
                                ))}
                            </div>
                            {/* <div className="drag-area">
                                <div className="icon">
                                    <i className="bi bi-cloud-arrow-up"
                                       aria-hidden="true"/>
                                </div>
                                <h5>Drag & Drop to Upload File here or click to
                                    upload</h5>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="modal-footer border border-top py-2 py-sm-1 ">
                    <button type="button" onClick={closeDocumentModel} className="btn grey_btn_outline"
                        data-bs-dismiss="offcanvas">Cancel
                    </button>
                </div>
            </div>

            {isPreviewModalOpen && (
                <DocumentPreviewModal
                    show={isPreviewModalOpen}
                    onClose={() => setIsPreviewModalOpen(false)}
                    title={previewFile?.name || 'File Preview'}
                >
                    {(() => {
                        const url = getPreviewUrl(previewFile);
                        const ext = getFileExtension(previewFile?.name);

                        if (!url) {
                            return <div className="text-center">Preview not available for this file.</div>;
                        }
                        if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext)) {
                            return <img src={url} alt={previewFile?.name} style={{ maxWidth: '100%', maxHeight: '70vh' }} />;
                        }
                        if (ext === "pdf") {
                            return <iframe src={url} title="PDF Preview" style={{ width: '100%', height: '70vh', border: 'none' }} />;
                        }
                        if (ext === "docx") {
                            if (isDocxLoading) {
                                return <div className="text-center">Loading DOCX preview...</div>;
                            }
                            return <div className="docx-preview p-3 bg-light rounded-3" style={{ maxHeight: '70vh', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: docxPreviewHtml }} />;
                        }
                        // For other files, show download link
                        return <div className="text-center">
                            <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download & View</a>
                            <div className="mt-2">Preview not supported for this file type.</div>
                        </div>;
                    })()}
                </DocumentPreviewModal>
            )}
        </div>
    );
}

export default DocumentViewTemplate;